export default "__VITE_ASSET__BgDLBDFQ__"